import { render, staticRenderFns } from "./Template55.vue?vue&type=template&id=69bc9efa&scoped=true&"
import script from "./Template55.vue?vue&type=script&lang=js&"
export * from "./Template55.vue?vue&type=script&lang=js&"
import style0 from "./Template55.vue?vue&type=style&index=0&id=69bc9efa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc9efa",
  null
  
)

export default component.exports